module.exports = __webpack_public_path__ + "static/media/30-14.5ef398d4.mp3";